module.exports = __webpack_public_path__ + "static/media/pnone-returns.67a89680.png";